import React from 'react';
import { cn } from '@/lib/utils';

export interface PageIntroProps {
  eyebrow?: React.ReactNode;
  title: string;
  description?: string;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
}

const colorSchemes = {
  emerald: 'bg-emerald-50 text-emerald-900 dark:bg-emerald-900/20 dark:text-emerald-100',
  blue: 'bg-brand-50 text-brand-900 dark:bg-brand-900/20 dark:text-brand-100',
  purple: 'bg-purple-50 text-purple-900 dark:bg-purple-900/20 dark:text-purple-100',
  amber: 'bg-amber-50 text-amber-900 dark:bg-amber-900/20 dark:text-amber-100',
};

export const PageIntro: React.FC<PageIntroProps> = ({
  eyebrow,
  title,
  description,
  icon,
  actions,
  footer,
  className = '',
}) => {
  const colorScheme = colorSchemes.blue;

  return (
    <div className={cn('rounded-2xl border border-slate-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800 p-6', className)}>
      <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-start">
        <div className="flex items-start gap-4">
          {icon && (
            <div className={cn('flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-2xl', colorScheme)}>
              {icon}
            </div>
          )}
          <div className="min-w-0">
            {eyebrow && (
              <div className="mb-2">{eyebrow}</div>
            )}
            <h1 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white">{title}</h1>
            {description && (
              <p className="mt-2 max-w-2xl text-sm text-slate-600 dark:text-slate-300">{description}</p>
            )}
          </div>
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
      {footer && (
        <div className="mt-6 flex flex-wrap items-center gap-x-3 gap-y-1 border-t border-slate-100 pt-4 text-xs text-slate-500 dark:border-gray-700 dark:text-gray-400">
          {footer}
        </div>
      )}
    </div>
  );
};
